import { getContentHeight } from 'components/sections/Navigation/utils';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useSport from 'store/sport';
import useScreen from 'hooks/useScreen';
import useDialog from 'store/dialog';
import { useSearchParams } from 'react-router-dom';
import useWindowResize from 'hooks/useWindowResize';
import SectionLoader from 'components/sections/SectionLoader/SectionLoader';

const LOGIN = 'loginClick';
const REGISTER = 'registrationClick';
const DEPOSIT = 'rechargeClick';
const ROUTE_CHANGED = 'routeChanged';
const SPORT_TAB_PARAM = 'tab';

const OneXBet = ({ sportId }: { sportId: string }) => {
  const ref = useRef(null);
  const [sportState] = useSport();
  const [, dialogActions] = useDialog();
  const [, setIsLoaded] = useState(false);
  const { isMobile } = useScreen();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get(SPORT_TAB_PARAM);

  const [height, setHeight] = useState<number>();

  const url = useMemo(() => {
    if (!sportState.data[sportId]) return;

    const { url, lang, sign, token } = sportState.data[sportId];

    const result = new URL(`${url}/${activeTab}`);
    result.searchParams.append('lng', lang);
    token ? result.searchParams.append('token', token) : result.searchParams.append('logout', '1');
    result.searchParams.append('sign', sign);
    result.searchParams.append('platform_type', isMobile ? 'mobile' : 'desktop');

    return result.toString();
  }, [sportState.data[sportId], isMobile]);

  useEffect(() => {
    if (!sportState.data[sportId]) return;

    const handler = (event) => {
      const { hostname } = new URL(sportState.data[sportId]?.url);
      if (event.origin.includes(hostname)) {
        switch (event.data.event) {
          case LOGIN:
            return dialogActions.set('signIn');
          case REGISTER:
            return dialogActions.set('signUp');
          case DEPOSIT:
            return dialogActions.set('deposit');
          case ROUTE_CHANGED: {
            return setSearchParams(
              (previousSearchParams) => {
                previousSearchParams.set(SPORT_TAB_PARAM, event.data.path);
                return previousSearchParams;
              },
              {
                replace: true,
              }
            );
          }
          default:
            break;
        }
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [sportState.data[sportId]]);

  const handleWindowHeight = useCallback(() => {
    setHeight(getContentHeight());
  }, []);

  useWindowResize(handleWindowHeight);

  if (!sportState.data[sportId]) return <SectionLoader />;

  return (
    <>
      <iframe
        ref={ref}
        src={url}
        referrerPolicy="no-referrer"
        onLoad={() => {
          setIsLoaded(true);
          setHeight(getContentHeight());
        }}
        style={{ width: '100%', border: 0, height }}
      />
    </>
  );
};

export default OneXBet;
